import { render } from "./client-segment-setting.vue?vue&type=template&id=44f8b8cc&scoped=true"
import script from "./client-segment-setting.vue?vue&type=script&lang=js"
export * from "./client-segment-setting.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./client-segment-setting.vue?vue&type=style&index=1&id=44f8b8cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f8b8cc"]])

export default __exports__